export const environment = {
	// @ts-ignore
	production: window['env']['environment'] === 'production',
	// @ts-ignore
	baseUrl: window['env']['apiUrl'] || 'default',
	// @ts-ignore
	urlApiValleLab: window['env']['urlApiValleLab'] || false,
	// @ts-ignore
	localSecret: window['env']['localSecret'] || false,
	// @ts-ignore
	secret: window['env']['secret'] || false,
	// @ts-ignore
	refreshSecret: window['env']['refreshSecret'] || false,
	// @ts-ignore
	adminUrl: window['env']['adminUrl'] || false,
	// @ts-ignore
	urlApiSegVial: window['env']['urlApiSegVial'] || false,
	// @ts-ignore
	urlApiValleMagico: window['env']['urlApiValleMagico'] || false,
	// @ts-ignore
	urlApiPertenezco: window['env']['urlApiPertenezco'] || false,
	// @ts-ignore
	urlApiGestionPedagogica: window['env']['urlApiGestionPedagogica'] || false,
	// @ts-ignore
	urlApiSapereAude: window['env']['urlApiSapereAude'] || false,
	// @ts-ignore
	urlApiCanvas: window['env']['urlApiCanvas'] || false,
	// @ts-ignore
	urlApiCatedra: window['env']['urlApiCatedra'] || false,
	// @ts-ignore
	passwordSegVial: window['env']['passwordSegVial'] || false,
	// @ts-ignore
	urlSST: window['env']['urlSST'] || false,
	// @ts-ignore
	urlChatBot: window['env']['urlChatBot'] || false,
	// @ts-ignore
	userSegVial: window['env']['userSegVial'] || false,
	// @ts-ignore
	urlChatBot: window['env']['urlChatBot'] || false,
	// @ts-ignore
	chatBotToken: window['env']['chatBotToken'] || false,
	// @ts-ignore
	chatBotId: window['env']['chatBotId'] || false,
	// @ts-ignore
	chatBotUrl: window['env']['chatBotUrl'] || false,
	// @ts-ignore
	chatBotSrc: window['env']['chatBotSrc'] || false,
};

